import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

interface TutorialStep {
  id: string;
  title: string;
  content: string;
  selector: string; // CSS selector to highlight
  position: 'top' | 'bottom' | 'left' | 'right';
}

// Tutorial steps are kept for future reference when we re-enable the tutorial
const tutorialSteps: TutorialStep[] = [
  {
    id: 'welcome',
    title: 'Welcome to Strykr AI',
    content: 'Your AI financial analyst is ready! Ask about specific stocks, trading strategies, or market trends to get personalized insights',
    selector: '.chat-input-container',
    position: 'top'
  },
  {
    id: 'power-tools',
    title: 'Analysis Tools',
    content: 'Customize your analysis: Toggle these AI models for deeper insights on specific aspects of your investment questions',
    selector: '.chat-toggles',
    position: 'bottom'
  },
  {
    id: 'market-pulse',
    title: 'Market Pulse',
    content: 'Real-time market pulse: This volatility score changes daily based on scheduled financial events that could impact your trades',
    selector: '.volatility-score',
    position: 'bottom'
  }
];

// Tutorial is disabled for now - will be updated in the future
export const TutorialOverlay = () => {
  return null;
};